'use strict';

const TOKEN_COOKIE_NAME = 't';
const USER_COOKIE_NAME = 'u';

const session = [
  '$rootScope',
  'Storage',

  function ($rootScope, Storage) {
    var storage = new Storage('cookie');
    var sessionData = null;


    function updateSessionData(newSessionData) {
      if (!angular.equals(sessionData, newSessionData)) {
        sessionData = newSessionData;
        $rootScope.$emit('session:changed', newSessionData);
      }
    }

    return {
      init: function () {
        var accessToken = storage.get(TOKEN_COOKIE_NAME);
        var userId = storage.get(USER_COOKIE_NAME);

        if (accessToken && userId) {
          updateSessionData({
            accessToken: accessToken,
            userId: userId
          });
        }
      },
      'set': function (newSessionData) {
        if (angular.isObject(newSessionData)) {
          storage.set(TOKEN_COOKIE_NAME, newSessionData.accessToken);
          storage.set(USER_COOKIE_NAME, newSessionData.userId);

          updateSessionData(newSessionData);
        } else {
          throw new Error('`sessionData` should be an object');
        }
      },

      'get': function () {
        return sessionData;
      },

      destroy: function () {
        storage.remove(TOKEN_COOKIE_NAME);
        storage.remove(USER_COOKIE_NAME);
        updateSessionData(null);
      }
    };
  }
];

export default session;



// WEBPACK FOOTER //
// ./app/src/services/session.js